<template>
  <div>
    <div v-if="btnSpin === false">
      <v-btn :color="ui.btnColor" flat dark
       @click="getUserData()"
      >
        <v-icon left>person</v-icon>
        Info
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin :btnSpec="btnInfo1"/>
    </div>
    <v-dialog v-model="dialog" persistent :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.cardColor">
        <v-card-title>
          <v-icon large left :color="ui.iconColor"> person </v-icon>
          <span :class="ui.textTitle"> {{this.localForm.username}} </span>
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :text-color="dataSavePendingColor">
            <v-icon> cloud </v-icon>
          </v-chip>
          <span :class="ui.textTitle">
            <div class="hidden-xs-only">
              {{displayDocumentIDGTypeA("U1", this.localForm.useridg)}}
            </div>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container :class="ui.bkgdColor">
            <v-layout row :class="ui.textSubheadingBold">
              <div class="ml-1 mt-2">
                User Details
              </div>
              <v-spacer/>
              <span :class="ui.textSubheadingBold">
                <div class="hidden-sm-and-up mt-2">
                  {{displayDocumentIDGTypeA("U1", this.localForm.useridg)}}
                </div>
              </span>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.username"
                prepend-icon="title"
                hint="user name"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                v-model="localForm.useremail"
                prepend-icon="mail"
                hint="email"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.ppri"
                :mask="mask"
                prefix="+61"
                prepend-icon="phone"
                hint="mobile phone"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                v-model="localForm.country"
                prepend-icon="public"
                hint="country"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.did"
                prepend-icon="fingerprint"
                hint="did"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                v-model="localForm.useridg"
                prepend-icon="badge"
                hint="generated id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="mt-4"/>
            <v-layout row :class="ui.textSubheadingBold">
              <div class="ml-1 mt-4">
                Access Status
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.act"
                prepend-icon="verified_user"
                hint="admin status"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.userActStatus"
                prepend-icon="person_add"
                hint="user status"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.rdp"
                prepend-icon="admin_panel_settings"
                hint="data privacy"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                v-model="localForm.rtc"
                prepend-icon="description"
                hint="terms and conditions"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row :class="ui.textSubheadingBold">
              <div class="ml-1 mt-2">
                User Verificaton
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.verify"
                prepend-icon="check_circle_outline"
                hint="user verified"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                v-model="localForm.averify"
                prepend-icon="task_alt"
                hint="admin verificaton"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row :class="ui.textSubheadingBold">
              <div class="ml-1 mt-4">
                Licence Status
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.rlic"
                prepend-icon="dashboard_customize"
                hint="licence"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <DatePicker :date= "{
                  obj: 'stats.dexp',
                  label: this.dateExp,
                  hint: 'expiry date',
                  icon: 'event_note'
                  }"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-layout row wrap class="ml-4 mr-4">
          <v-spacer/>
          <v-btn
           @click="changeUserVerify()"
           :color="btnUserVerify.color"
           :disabled="this.localForm.act !== 'Active'"
           flat
          >
            <v-icon left> {{btnUserVerify.icon}} </v-icon>
              {{btnUserVerify.title}}
          </v-btn>
          <v-btn
            @click="changeUserLicence()"
            :color="btnUserLicence.color"
            :disabled="this.localForm.act !== 'Active'"
            flat
          >
            <v-icon left> {{btnUserLicence.icon}} </v-icon>
              {{btnUserLicence.title}}
          </v-btn>
          <!-- <div v-if="this.localForm.act === 'Active'">
            <v-btn
              @click="changeUserLicence()"
              :color="btnUserLicence.color"
              :disabled="this.localForm.act !== 'Active'"
              flat
            >
              <v-icon left> {{btnUserLicence.icon}} </v-icon>
                {{btnUserLicence.title}}
              </v-btn>
            <v-btn
              class="hidden-sm-and-up"
              @click="changeUserLicence()"
              :color="btnUserLicence.color"
              flat
            >
              <v-icon left :color="btnUserLicence.color">
                {{btnUserLicence.icon}}
              </v-icon>
              {{btnUserLicence.titleSmall}}
            </v-btn>
          </div> -->

        </v-layout>
        <v-layout row wrap class="ml-4 mr-4 mt-4">
          <v-btn
          @click="closeDialog()" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          <div>
            <v-btn
              @click="changeUserStatus()"
              :color="btnUserStatus.color"
              flat
            >
              <v-icon left> {{btnUserStatus.icon}} </v-icon>
                {{btnUserStatus.title}}
            </v-btn>
          </div>
        </v-layout>
        <v-card-actions>
          <v-layout row>
            <v-spacer/>
            <DetailAdmin :data="{tag: 'U1'}"/>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import DatePicker from "@/data/functions/components/DatePicker";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import DetailAdmin from "@/support/detail/components/DetailAdmin";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import { mapGetters } from "vuex";
export default {
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin,
    DetailAdmin,
    DatePicker
  },
  watch: {
    dataSaved() {
      if (this.ctr === 1) {
        this.ctr = this.ctr + 1;
        console.log("Open ONCE ONLY");
        this.dialog = true;
        if (this.getInfoCard.basic.tag === "U1") {
          let udid = this.getInfoCard.basic.did;
          this.$store.dispatch("changeUserDID", udid);
        }
      }
    }
  },
  mixins: [
    apptheme,
    createFirebase,
    numberFunctions,
    getData,
    docLogFunctions,
    displayFunctions,
    dateFunctions
  ],
  data() {
    return {
      valid: true,
      dialog: false,
      mask: "### ### ###",
      ctr: 0, // this prevent bounce that lead to overstack limt
      btnSpin: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      },
      localForm: {
        country: "Australia",
        ppri: "",
        dexp: "",
        did: "",
        rlic: "",
        rdp: "",
        rtc: "",
        username: "",
        useremail: "",
        userphone: "",
        useridg: "",
        averify: "", // admin verified
        verify: "", // user verified
        lcountry: "", // company or facility
        lstate: "", // company or facility
        rtrade: "",
        rpos: "",
        rdes: ""
      }
    };
  },
  updated() {
    // fix orginal data before change
    if (this.getInfoCard !== null) {
      // CONST
      this.localForm.rdp = this.getInfoCard.basic.rdp;
      this.localForm.rtc = this.getInfoCard.basic.rtc;

      this.localForm.did = this.getInfoCard.basic.did;
      this.localForm.userActStatus = this.getInfoCard.basic.act;
      this.localForm.username = this.getInfoCard.basic.title;
      this.localForm.useremail = this.getInfoCard.basic.email;
      this.localForm.useridg = this.getInfoCard.basic.idg;
      this.localForm.userphone = this.getInfoCard.char.phoneMob;
      this.localForm.ppri = this.getInfoCard.char.ppri;

      this.localForm.verify = this.getInfoCard.basic.verify;

      this.localForm.lcountry = this.getInfoCard.char.lcountry;
      this.localForm.lstate = this.getInfoCard.char.lstate;

      this.localForm.rtrade = this.getInfoCard.char.rtrade;
      this.localForm.rpos = this.getInfoCard.char.rpos;
      this.localForm.rdes = this.getInfoCard.char.rdes;
      this.localForm.rctitle = this.getInfoCard.char.rctitle;
    }
    // LOCAL ACTVE
    if (this.localForm.userActStatus === true) {
      this.localForm.userActStatus = "Active";
    } else {
      this.localForm.userActStatus = "Disabled";
    }
    // REMOTE ACTIVE
    if (this.getStatsRemote !== null) {
      // CHANGE
      this.localForm.dexp = this.dateTypeA(this.getStatsRemote.dexp);
      this.localForm.rlic = this.getStatsRemote.rlic;
      this.localForm.averify = this.getStatsRemote.averify;
      if (this.getStatsRemote.act === true) {
        this.localForm.act = "Active";
      } else {
        this.localForm.act = "Disabled";
      }
    }
  },
  computed: {
    ...mapGetters([
      "getInfoCard",
      "getAdmin",
      "getAdminBasic",
      "getStatsRemote"
    ]),
    dataSaved() {
      let saved = false;
      if (this.getInfoCard !== null && this.ctr === 1) {
        saved = true;
        // this.ctr = this.ctr + 1;
      } else {
        saved = false;
      }
      return saved;
    },
    dateExp() {
      let d = null;
      if (this.getStatsRemote !== null && this.getStatsRemote !== undefined) {
        d = this.dateTypeA(this.getStatsRemote.dexp);
      } else {
        d = this.localForm.dexp;
      }
      return d;
    },
    dataSavePendingColor() {
      // eslint-disable-next-line
      if (this.getDataSavePendingIndication === true) {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    },
    btnUserStatus() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.getStatsRemote !== null && this.getStatsRemote.act === true) {
        obj.title = "user";
        obj.icon = "lock";
        obj.color = this.ui.colorError;
      } else {
        obj.title = "user";
        obj.icon = "lock_open";
        obj.color = this.ui.colorWarning;
      }
      return obj;
    },
    btnUserLicence() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.getStatsRemote !== null && this.getStatsRemote.rlic === "Free") {
        obj.title = "licence";
        obj.titleSmall = "Lic.";
        obj.icon = "upgrade";
        obj.color = this.ui.colorWarning;
      } else {
        obj.title = "licence";
        obj.titleSmall = "Free";
        obj.icon = "arrow_circle_down";
        obj.color = this.ui.colorError;
      }
      return obj;
    },
    btnUserVerify() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.getStatsRemote !== null && this.getStatsRemote.averify === "") {
        obj.title = "verify";
        obj.icon = "check_circle_outline";
        obj.color = this.ui.colorError;
      } else if (
        this.getStatsRemote !== null &&
        this.getStatsRemote.averify === "L1"
      ) {
        obj.title = "verify L2";
        obj.titleSmall = "L2";
        obj.icon = "check_circle_outline";
        obj.color = this.ui.colorWarning;
      } else {
        obj.title = "verify L1";
        obj.titleSmall = "L1";
        obj.icon = "radio_button_unchecked";
        obj.color = this.ui.colorError;
      }
      return obj;
    }
  },
  methods: {
    changeUserStatus() {
      let temp = this.getStatsRemote;
      let status = !this.getStatsRemote.act;
      let verify = this.getStatsRemote.averify;
      temp.averify = verify;
      temp.act = status;
      // console.log(status);
      if (status === true) {
        this.localForm.act = "Active";
        this.localForm.averify = "L1";
        temp.averify = "L1";
      } else {
        this.localForm.act = "Disabled";
      }
      // change admin
      this.$store.dispatch("changeStatsRemote", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
    },
    changeUserLicence() {
      let temp = this.getStatsRemote;
      let licence = null;
      if (temp.rlic === "Free") {
        licence = "Unlimited";
      } else {
        licence = "Free";
      }
      temp.rlic = licence;
      this.localForm.rlic = licence;
      // change admin
      this.$store.dispatch("changeStatsRemote", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      // update user log
    },
    changeUserVerify() {
      let temp = this.getStatsRemote;
      let verify = null;
      if (temp.averify === "" || temp.averify === "L1") {
        verify = "L2";
      } else {
        verify = "L1";
      }
      temp.averify = verify;
      this.localForm.averify = verify;
      // change admin
      this.$store.dispatch("changeStatsRemote", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      // update user log
    },
    closeDialog() {
      // reset store
      // this.$store.dispatch("changeUserSec", null);
      this.btnSpin = false;
      this.dialog = false;
      this.ctr = 0;
    },
    getUserData() {
      if (this.ctr === 0) {
        this.ctr = this.ctr + 1;
        this.btnSpin = true;
        this.getDocumentInfoCard("U1", this.data.basic.did);
      }
    }
  }
};
</script>
